import { ChevronDown } from "lucide-react"

export function ScrollIndicator({ className = "" }) {
  return (
    <div className={`flex flex-col items-center gap-2 ${className}`}>
      <span className="text-xs uppercase tracking-widest text-current opacity-60">
        Scroll to explore
      </span>
      <ChevronDown className="w-6 h-6 text-current opacity-60 animate-bounce" />
    </div>
  )
}

export default ScrollIndicator
